module.exports = __webpack_public_path__ + "static/media/instagram.60adc45d.svg";